import { AdRequestParameter } from './ad-request-parameter.model';
import { ApiBind, Common } from './common.model';

/**
 * 広告リクエストの登録・編集で送信するリクエストボディ情報.
 *
 * @exports
 * @extends Common
 */
export class AdRequestPostRequest extends Common {
  @ApiBind({ column: 'id' })
  id: number;

  @ApiBind({ column: 'name' })
  name: string;

  @ApiBind({ column: 'ad_format' })
  adFormat: number;

  @ApiBind({ column: 'placement_id' })
  placementId: number;

  @ApiBind({
    column: 'ad_request_format_template_id',
  })
  adRequestFormatTemplateId: number;

  @ApiBind({
    column: 'ad_request_parameter_template_id',
  })
  adRequestParameterTemplateId?: number;

  @ApiBind({
    column: 'ad_request_parameters',
    model: (values) => values.map((value) => new AdRequestParameter(value)),
  })
  adRequestParameters: AdRequestParameter[];

  @ApiBind({ column: 'platform_frame_name' })
  platformFrameName: string;

  @ApiBind({ column: 'memo' })
  memo: string;

  @ApiBind({ column: 'updated_at' })
  updatedAt: string;
}
